import React, { useEffect, useState } from "react";
import {
    Box,
    Flex,
    Text,
    VStack,
    HStack,
    Divider,
    Avatar,
    IconButton,
    Tabs,
    TabList,
    TabPanels,
    Tab,
    TabPanel,
    useColorModeValue,
    useToast,
    useBreakpointValue,
} from "@chakra-ui/react";
import {
    FaBookOpen,
    FaCalendarAlt,
    FaClipboardList,
    FaDollarSign,
    FaFileAlt,
    FaUniversity,
    FaLock,
} from "react-icons/fa";
import Timetable from "./Tab_components/Timetable";
import Teacher_Profile_BusFee_Design from "../../../Bus/TeacherBusFee/Teacher_Profile_BusFee_Design";
import Teacher_Dashboard_Lib_design from "../../../Library/Profile_Teacher/Teacher_Dashboard_Lib_design";
import { BASE_URL } from "../../../../Globalapi/Globalapi";

const StudentDetailsView = () => {
    const [studentData, setStudentData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [parentsData, setParentsData] = useState([]);
    const toast = useToast();

    const borderColor = useColorModeValue("gray.200", "gray.700");
    const blueColor = useColorModeValue("blue.600", "white");
    const bgColor = useColorModeValue("blue.100", "blue.900");
    const hoverBgColor = useColorModeValue("blue.200", "blue.800");
    const grayHoverBg = useColorModeValue("gray.200", "gray.700");

    const navigationItems = [
        { icon: FaBookOpen, label: "Personal Details" },
        { icon: FaCalendarAlt, label: "Time Table" },
        { icon: FaDollarSign, label: "Bus Fee" },
        { icon: FaDollarSign, label: "Library" },
    ];

    const isMobile = useBreakpointValue({ base: true, md: false }); // Use 'base' for mobile screens

    useEffect(() => {
        const userId = sessionStorage.getItem("user_id");
        const fetchStudentData = async () => {
            try {
                const response = await fetch(`${BASE_URL}/staff/profile/staff_profile.php`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({ pass: userId }),
                });
                const data = await response.json();
                if (data.success) {
                    setStudentData(data.data);
                    const parentsData = [
                        {
                            name: data.data.guardian_name,
                            relation: data.data.relation,
                            phone: data.data.guardian_contact_no,
                            email: data.data.email,
                        },
                    ];
                    setParentsData(parentsData);
                } else {
                    setError("Failed to fetch student data.");
                    toast({
                        title: "Error",
                        description: "Failed to fetch student data.",
                        status: "error",
                        duration: 3000,
                        isClosable: true,
                    });
                }
            } catch (err) {
                setError("An error occurred while fetching data.");
                toast({
                    title: "Error",
                    description: "An error occurred while fetching data.",
                    status: "error",
                    duration: 3000,
                    isClosable: true,
                });
            } finally {
                setLoading(false);
            }
        };
        fetchStudentData();
    }, [toast]);

    return (
        <Box pl={6} pb={6} pr={6} w="full">
            {/* Tabs for large devices */}
            {!isMobile ? (
                <Tabs variant="line" colorScheme="teal">
                    <TabList borderBottom="none">
                        {navigationItems.map((item, index) => (
                            <Tab key={index}>
                                <Flex align="center" gap={2}>
                                    <item.icon />
                                    <Text fontSize="sm">{item.label}</Text>
                                </Flex>
                            </Tab>
                        ))}
                    </TabList>

                    <TabPanels>
                        <TabPanel>
                            <Box border="1px" borderRadius="md" p={4} borderColor={borderColor}>
                                <Flex justify="space-between" align="center" borderBottom="1px" pb={4} borderColor={borderColor}>
                                    <Text fontSize="lg" fontWeight="medium">
                                        Guardian Information
                                    </Text>
                                    <IconButton
                                        icon={<FaLock />}
                                        size="sm"
                                        aria-label="Lock information"
                                        bg={bgColor}
                                        color={blueColor}
                                        _hover={{ bg: hoverBgColor }}
                                    />
                                </Flex>

                                <VStack spacing={4} mb={4} divider={<Divider />}>
                                    {parentsData && parentsData.length > 0 ? (
                                        parentsData.map((parent, index) => (
                                            <Flex key={index} mt={4} w="full" align="center">
                                                <Avatar src="/api/placeholder/48/48" size="md" name={parent.name} mr={4} />
                                                <HStack spacing={8} flex="1" align="start">
                                                    <VStack align="start" spacing={0}>
                                                        <Text fontWeight="medium">{parent.name}</Text>
                                                        <Text fontSize="sm" color="blue.600">
                                                            {parent.relation}
                                                        </Text>
                                                    </VStack>
                                                    <VStack align="start" spacing={0}>
                                                        <Text fontSize="sm" color="gray.600">
                                                            Phone
                                                        </Text>
                                                        <Text fontSize="sm">{parent.phone}</Text>
                                                    </VStack>
                                                    <VStack align="start" spacing={0}>
                                                        <Text fontSize="sm" color="gray.600">
                                                            Email
                                                        </Text>
                                                        <Text fontSize="sm">{parent.email}</Text>
                                                    </VStack>
                                                </HStack>
                                                <IconButton
                                                    icon={<FaLock />}
                                                    size="sm"
                                                    aria-label="Lock"
                                                    _hover={{
                                                        bg: grayHoverBg,
                                                    }}
                                                />
                                            </Flex>
                                        ))
                                    ) : (
                                        <Text>No Guardian information available</Text>
                                    )}
                                </VStack>
                            </Box>
                        </TabPanel>

                        <TabPanel>
                            <Timetable />
                        </TabPanel>

                        <TabPanel>
                            <Teacher_Profile_BusFee_Design />
                        </TabPanel>

                        <TabPanel>
                            <Teacher_Dashboard_Lib_design />
                        </TabPanel>
                    </TabPanels>
                </Tabs>
            ) : (
                // Components for small screens (stack them vertically)
                <VStack spacing={6}>
                    <Box w="full" border="1px" borderRadius="md" p={4} borderColor={borderColor}>
                        <Text fontSize="lg" fontWeight="medium" mb={4}>
                            Guardian Information
                        </Text>
                        {parentsData && parentsData.length > 0 ? (
                            parentsData.map((parent, index) => (
                                <Flex key={index} w="full" align="center" mb={4}>
                                    <Avatar src="/api/placeholder/48/48" size="md" name={parent.name} mr={4} />
                                    <VStack align="start" spacing={0}>
                                        <Text fontWeight="medium">{parent.name}</Text>
                                        <Text fontSize="sm" color="blue.600">
                                            {parent.relation}
                                        </Text>
                                        <Text fontSize="sm" color="gray.600">
                                            Phone: {parent.phone}
                                        </Text>
                                        <Text fontSize="sm" color="gray.600">
                                            Email: {parent.email}
                                        </Text>
                                    </VStack>
                                </Flex>
                            ))
                        ) : (
                            <Text>No Guardian information available</Text>
                        )}
                    </Box>

                    <Box w="full">
                        <Timetable />
                    </Box>

                    <Box w="full">
                        <Teacher_Profile_BusFee_Design />
                    </Box>

                    <Box w="full">
                        <Teacher_Dashboard_Lib_design />
                    </Box>
                </VStack>
            )}
        </Box>
    );
};

export default StudentDetailsView;
